// ==========================================
// 1. CRÉER LE GUARD : src/app/_guards/profile.guard.ts
// ==========================================

import { Injectable } from '@angular/core';
import { 
  CanActivate, 
  ActivatedRouteSnapshot, 
  RouterStateSnapshot, 
  Router 
} from '@angular/router';
import { AuthService } from '../_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileGuard implements CanActivate {

  // Définir les profils autorisés
  private readonly SUPER_ADMIN = 'profile_code_1';
  private readonly POS_ADMIN = 'profile_code_2';

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    
    console.log('[ProfileGuard] Vérification accès à:', state.url);
    
    // 1. Récupérer l'utilisateur connecté
    const currentUser = this.auth.getCurrentUser();
    
    // 2. Si pas d'utilisateur, rediriger vers login
    if (!currentUser || !currentUser.profilCode) {
      console.error('[ProfileGuard] Utilisateur non connecté');
      this.router.navigate(['/welcome/thankyou']);
      return false;
    }
    
    const userProfile = currentUser.profilCode;
    console.log('[ProfileGuard] Profil utilisateur:', userProfile);
    
    // 3. Récupérer les profils autorisés depuis la config de la route
    const allowedProfiles = route.data['allowedProfiles'] || [];
    console.log('[ProfileGuard] Profils autorisés:', allowedProfiles);
    
    // 4. Si aucun profil défini, autoriser (route publique)
    if (allowedProfiles.length === 0) {
      return true;
    }
    
    // 5. Vérifier si le profil utilisateur est autorisé
    if (allowedProfiles.includes(userProfile)) {
      console.log('[ProfileGuard] ✅ Accès autorisé');
      return true;
    }
    
    // 6. Accès refusé - Rediriger vers menu principal
    console.error('[ProfileGuard] ❌ Accès refusé pour profil:', userProfile);
    this.router.navigate(['/welcome/not-found']);
    return false;
  }
}